<div [attr.data-test-id]="tabMenuId()">
	@if (useButtonVariant()) {
		<div class="flex flex-col gap-2">
			@if (!hideTabs()) {
				<div
					[ngClass]="numberOfColumnsTab()"
					class="grid grid-cols-2 gap-1"
				>
					@for (tab of tabMenuItems(); track $index) {
						<button
							[attr.data-test-id]="tab.name"
							[class]="backgroundColor()"
							[ngClass]="{
								'overflow-hidden !bg-accent-25 text-accent-100 before:absolute before:bottom-0 before:h-0.5 before:w-full before:bg-accent-100 before:content-empty':
									activeTab() === $index,
							}"
							(click)="setActiveTab($index)"
							class="relative inline-flex w-full items-center justify-center rounded-tab-menu border border-ui-100 p-3 font-semibold hover:border-ui-150"
							data-test-class="tab-button"
						>
							{{ tab.label }}
						</button>
					}
				</div>
			}
			<div
				class="list-checkmarks flex flex-col gap-4 card card-lg"
				data-test-class="tab-content"
			>
				@if (tabMenuItems()?.[activeTab()]?.content) {
					<ng-container
						*ngTemplateOutlet="tabMenuItems()[activeTab()].content"
					/>
				}
			</div>
		</div>
	} @else {
		<div [class]="cn(`relative flex flex-col ${containerGapClass()}`)">
			<div
				#tabMenuContainer
				[ngClass]="backgroundColor()"
				(scroll)="onScroll($event)"
				(wheel)="onWheel($event)"
				aria-label="Tab navigation"
				class="flex [scrollbar-width:none] flex-row justify-between overflow-x-scroll border-b border-ui-125 [-ms-overflow-style:none] sm:justify-start [&::-webkit-scrollbar]:hidden"
				role="tablist"
				tabindex="-1"
			>
				@for (tab of tabMenuItems(); track $index) {
					<a
						[attr.aria-selected]="activeTab() === $index"
						[attr.data-name]="tab.name"
						[attr.data-test-id]="tab.name"
						[attr.tabindex]="activeTab() === $index ? 0 : -1"
						[ngClass]="{
							'border-b-2 border-accent-100 opacity-100':
								activeTab() === $index,
							'mb-0.5 opacity-75 hover:mb-0':
								activeTab() !== $index,
							'grow basis-0 text-center': stretchTabs(),
						}"
						(click)="setActiveTab($index)"
						(keydown)="onTabKeydown($event, $index)"
						class="btn w-full rounded-none btn-text px-4 pt-3.5 pb-2.5 text-base !-outline-offset-2 hover:border-b-2 hover:border-accent-100 hover:opacity-100 sm:text-lg md:w-auto md:px-5"
						data-test-class="tab-button"
						role="tab"
					>
						{{ tab.label }}
					</a>
				}
			</div>
			@if (canScroll() && !isAtStart()) {
				<div
					[ngClass]="startGradient()"
					class="absolute top-0 left-0 h-12 w-8 bg-gradient-to-r to-transparent"
				></div>
			}
			@if (canScroll() && !isAtEnd()) {
				<div
					[ngClass]="endGradient()"
					class="absolute top-0 right-0 h-12 w-8 bg-gradient-to-r from-transparent"
				></div>
			}
			@if (tabMenuItems()?.[activeTab()]?.content) {
				<div class="contents" data-test-class="tab-content">
					<ng-container
						*ngTemplateOutlet="tabMenuItems()[activeTab()].content"
					/>
				</div>
			}
		</div>
	}
</div>
